import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SegmentPoint } from '../models/segment-point';
import { ElevationPoiType} from '../models/elevation-poi';

@Injectable({
  providedIn: 'root'
})
export class ProfilePathService {

  private activatedMapPointSubject = new Subject<SegmentPoint>();
  readonly $activatedMapPoint = this.activatedMapPointSubject.asObservable();

  private clickedProfilePointSubject = new Subject<SegmentPoint>();
  readonly $clickedProfilePoint = this.clickedProfilePointSubject.asObservable();

  private hoveredProfilePointSubject = new Subject<SegmentPoint>();
  readonly $hoveredProfilePoint = this.hoveredProfilePointSubject.asObservable();

  private clickedProfilePointOfInterestSubject = new Subject<ElevationPoiType>();
  readonly $clickedProfilePointOfInterest = this.clickedProfilePointOfInterestSubject.asObservable();

  private hoveredProfilePointOfInterestSubject = new Subject<ElevationPoiType>();
  readonly $hoveredProfilePointOfInterest = this.hoveredProfilePointOfInterestSubject.asObservable();

  activateMapPoint(pt: SegmentPoint) {
    this.activatedMapPointSubject.next(pt);
  }

  onHoverProfilePoint(pt: SegmentPoint) {
    this.hoveredProfilePointSubject.next(pt);
  }

  onClickProfilePoint(pt: SegmentPoint) {
    this.clickedProfilePointSubject.next(pt);
  }

  onHoverProfilePointOfInterest(poi: ElevationPoiType) {
    this.hoveredProfilePointOfInterestSubject.next(poi);
  }

  onClickProfilePointOfInterest(poi: ElevationPoiType) {
    this.clickedProfilePointOfInterestSubject.next(poi);
  }

}
